module.exports = __webpack_public_path__ + "img/sxsjs9.a59e2b75.png";